import { useMemo } from 'react'

export const useHeaderContent = ({
  headerData,
  headerOverride,
  region
}: {
  headerData: any
  headerOverride?: any
  region: any
}) =>
  useMemo(() => {
    if (headerOverride) {
      return headerOverride.pageHeader.find((f: any) => f.country === region)
    }
    return headerData.find((f: any) => f.country === region)
  }, [headerData, headerOverride, region])

export const useFooterContent = ({
  footerData,
  footerOverride,
  region
}: {
  footerData: any
  footerOverride?: any
  region?: any
}) =>
  useMemo(() => {
    if (footerOverride) {
      return footerOverride.pageFooter.find((f: any) => f.country === region)
        ?.footerContent
    }
    return footerData.find((f: any) => f.country === region)?.footerContent
  }, [footerData, footerOverride, region])
